<script>
export default {
  name: 'FlashNotice',
  props: {
    backgroundColour: {
      type: String,
      default: 'purple'
    },
    textColour: {
      type: String,
      default: 'white'
    },
    alignIcon: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    background() {
      return `flash-notice--${this.backgroundColour}`
    },
    text() {
      return `flash-notice__message--${this.textColour}`
    }
  }
}
</script>

<template lang="pug">
.flash-notice(:class='background')
  .flash-notice__icon(:class='`align-${alignIcon}`')
    slot(name='icon')
  .flash-notice__message(:class='text')
    slot(name='text')
</template>

<style lang="stylus" scoped>
@import '../../assets/styles/modules/*'

.flash-notice
  display flex
  position: relative
  padding: 15px
  width: 100%
  radius(lg)
  shadow(md)

  for colour in THRIVA.colours
    &--{colour}
      background-color: THRIVA.colours[colour]

  +media-breakpoint-up(md)
    display: flex
    padding: 12px 20px

  &__message
    display flex
    flex-wrap: nowrap
    p
      font-weight: THRIVA.typography.font-weights.light
      max-width: 100%

    for colour in THRIVA.colours
      &--{colour}
        p
          color: THRIVA.colours[colour]

  &__icon
    display: flex
    flex-wrap: nowrap

    &.align-top
      margin-top: 5px
      margin-right: 5px

    img
      height: 16px
      width: 16px
      margin-right: 10px
</style>
